import { DiscountCodeBase } from '../../contracts/discount-code.js';
import { VersionRange } from '../../models/core/version-range.js';
import {
  cloneListOfCloneable, DataModelBuilder, isSameData, isSameList, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OrderDiscountCodeComponent extends Component {
  static readonly TYPE_ID: string = 'f4f455e44cfd47cba9976dc2685f5c56';
  static readonly SCHEMA_VERSION: number = 1;

  private constructor(
    public readonly codes: DiscountCodeBase[],
  ) {
    super();
  }

  get $typeId(): string {
    return OrderDiscountCodeComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.exactly(OrderDiscountCodeComponent.SCHEMA_VERSION);
  }

  static create(args: { codes: DiscountCodeBase[] }): OrderDiscountCodeComponent {
    return new OrderDiscountCodeComponent(args.codes);
  }

  static fromMap(context: SerializationContext, map: SerializedData): OrderDiscountCodeComponent {
    return this.create({
      codes: MapUtils.getList<DiscountCodeBase>(map, 'codes', (v) => context.fromData<DiscountCodeBase>(v as SerializedData)),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'codes': this.codes.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return OrderDiscountCodeComponent.create({
      codes: cloneListOfCloneable(this.codes),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.codes, this.codes, isSameData);
  }
}

export class OrderDiscountCodeComponentBuilder extends DataModelBuilder<OrderDiscountCodeComponent> {
  build(context: SerializationContext, map: SerializedData): OrderDiscountCodeComponent {
    return OrderDiscountCodeComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);
    if(versionRange.contains(OrderDiscountCodeComponent.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(OrderDiscountCodeComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    const version = versionRange.to;

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
